import React, { useState, useEffect } from 'react';
import Udesk from 'Udesk';
import { Form, Input, Select, Button, Space } from 'udesk-ui';
import { getIntelligentPartnerCustomerPersonas } from 'src/api/intelligentPartnerCustomerPersonas';
import { putReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdById } from 'src/api/review/intelligentPartner/node/inputSceneConfig/manage/updateSceneById/{id}/index';
import { useSdkOptions } from 'src/util/hook';
import {
    IntelligentPartnerCustomerPersonaFoundResponse,
    IntelligentPartnerDialogNodeAiTemplate,
} from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

const CreateDialogue: React.FC<any> = ({ history, match, location }) => {
    const sdkOptions = useSdkOptions();
    const [form] = Form.useForm<IntelligentPartnerDialogNodeAiTemplate>();
    const [allCustomerPortrait, setAllCustomerPortrait] = useState<
        IntelligentPartnerCustomerPersonaFoundResponse[]
    >([]);
    const isEdit = Boolean(match?.params?.id);
    const [loading, setLoading] = useState(false);

    const requestAllCustomerPortrait = () => {
        getIntelligentPartnerCustomerPersonas().then((resp) => {
            setAllCustomerPortrait(resp.data ?? []);
            if (isEdit) {
                fetchSceneDetail();
            }
        });
    };

    const fetchSceneDetail = () => {
        const record = location.state.record;
        form.setFieldsValue({
            templateName: record.templateName,
            dialogueScene: record.dialogueScene,
            sparringPartner: record.sparringPartner,
            simulatedRole: record.simulatedRole,
            remark: record.remark,
        });
    };

    useEffect(() => {
        requestAllCustomerPortrait();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // 提交表单
    const handleSubmit = (values: any) => {
        setLoading(true);
        if (isEdit) {
            putReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdById(values, {
                segments: {
                    id: match.params.id,
                },
            })
                .then((res) => {
                    console.log('res', res);
                    Udesk.ui.notify.success(
                        /* 编辑场景成功 */ UdeskLocales['current'].pages.coach.templateManage
                            .dialogueManage.edit.editSceneSuccessfully
                    );
                    history.goBack();
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            const url = Udesk.business.apiPath.concatApiPath(
                `/review/intelligentPartner/node/inputSceneConfig/manage/templateAdd`,
                sdkOptions
            );
            Udesk.ajax
                .post(url, values)
                .then(
                    () => {
                        Udesk.ui.notify.success(
                            /* 创建场景成功 */ UdeskLocales['current'].pages.coach.templateManage
                                .dialogueManage.edit.sceneCreatedSuccessfully
                        );
                        history.goBack();
                    },
                    (reason) => {
                        Udesk.ui.notify.error(reason.errorMsg);
                    }
                )
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    // 取消
    const handleCancel = () => {
        history.goBack();
    };

    return (
        <div className="create-dialogue">
            <Form
                form={form}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 16 }}
                onFinish={handleSubmit}
                className="create-dialogue-form"
                initialValues={{
                    name: '',
                    description: '',
                    targetUsers: '',
                    roleId: '',
                    remark: '',
                }}
            >
                {/* 场景名称 */}
                <Form.Item
                    label={
                        /* 场景名称 */ UdeskLocales['current'].pages.coach.templateManage
                            .dialogueManage.edit.sceneName
                    }
                    name="templateName"
                    required
                    rules={[
                        {
                            required: true,
                            message:
                                /* 请输入场景名称 */ UdeskLocales['current'].pages.coach
                                    .templateManage.dialogueManage.edit.pleaseEnterASceneName,
                        },
                    ]}
                >
                    <Input
                        placeholder={
                            /* 请输入 */ UdeskLocales['current'].pages.coach.templateManage
                                .dialogueManage.edit.pleaseEnter
                        }
                        maxLength={40}
                        showCount
                    />
                </Form.Item>

                {/* 场景描述 */}
                <Form.Item
                    label={
                        /* 场景描述 */ UdeskLocales['current'].pages.coach.templateManage
                            .dialogueManage.edit.scenarioDescription
                    }
                    name="dialogueScene"
                    required
                    rules={[
                        {
                            required: true,
                            message:
                                /* 请输入场景描述 */ UdeskLocales['current'].pages.coach
                                    .templateManage.dialogueManage.edit
                                    .pleaseEnterASceneDescription,
                        },
                    ]}
                >
                    <Input.TextArea
                        placeholder={`${
                            /* 根据您的陪练目的输入相应得场景描述。例如：客户想要为家人购置重疾险，销售人员通过电话与他介绍保险产品以及保障。可在描述中提供该场景下可能出现得具体事件，场景描述越详细，所构建的对话流程或框架则会越精准，效果则会更佳。 */ UdeskLocales[
                                'current'
                            ].pages.coach.templateManage.dialogueManage.edit
                                .enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleIfACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyTheSalespersonIntroducesTheInsuranceProductsAndProtectionToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe
                        }`}
                        rows={6}
                    />
                </Form.Item>

                {/* 面板对象(学员) */}
                <Form.Item
                    label={
                        /* 面板对象(学员) */ UdeskLocales['current'].pages.coach.templateManage
                            .dialogueManage.edit.panelObjectStudent
                    }
                    name="sparringPartner"
                    required
                    rules={[
                        {
                            required: true,
                            message:
                                /* 请输入面板对象 */ UdeskLocales['current'].pages.coach
                                    .templateManage.dialogueManage.edit.pleaseEnterAPanelObject,
                        },
                    ]}
                >
                    <Input
                        placeholder={
                            /* 请输入 */ UdeskLocales['current'].pages.coach.templateManage
                                .dialogueManage.edit.pleaseEnter
                        }
                        maxLength={40}
                        showCount
                    />
                </Form.Item>

                {/* 建议角色(机器人) */}
                <Form.Item
                    label={
                        /* 建议角色(机器人) */ UdeskLocales['current'].pages.coach.templateManage
                            .dialogueManage.edit.proposedRolesRobots
                    }
                    name="simulatedRole"
                    required
                    rules={[
                        {
                            required: true,
                            message:
                                /* 请选择建议角色 */ UdeskLocales['current'].pages.coach
                                    .templateManage.dialogueManage.edit.pleaseSelectASuggestedRole,
                        },
                    ]}
                >
                    <Select
                        placeholder={
                            /* 请输入角色名称 */ UdeskLocales['current'].pages.coach.templateManage
                                .dialogueManage.edit.pleaseEnterARoleName
                        }
                    >
                        {allCustomerPortrait.map((item) => (
                            <Select.Option key={item.id} value={item.id!!}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                {/* 备注 */}
                <Form.Item
                    label={
                        /* 备注 */ UdeskLocales['current'].pages.coach.templateManage.dialogueManage
                            .edit.remarks
                    }
                    name="remark"
                >
                    <Input
                        placeholder={
                            /* 请输入 */ UdeskLocales['current'].pages.coach.templateManage
                                .dialogueManage.edit.pleaseEnter
                        }
                        maxLength={40}
                        showCount
                    />
                </Form.Item>

                {/* 操作按钮 */}
                <Form.Item className="form-actions" wrapperCol={{ span: 16, offset: 4 }}>
                    <Space>
                        <Button onClick={handleCancel}>
                            {/* 取消 */}
                            {
                                UdeskLocales['current'].pages.coach.templateManage.dialogueManage
                                    .edit.cancel
                            }
                        </Button>
                        <Button loading={loading} type="primary" htmlType="submit">
                            {/* 保存 */}
                            {
                                UdeskLocales['current'].pages.coach.templateManage.dialogueManage
                                    .edit.save
                            }
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    );
};

export default CreateDialogue;
